import React from "react";
import {
    ReviewPageLeftSection,
    AuthCode,
    Heading,
    Paragraph,
    Span,
} from "./ReviewClassLeftSection.styles";
import {DetailContainer,
    DetailCard,
    DetailCardWrapper, } from "../../ReviewClassDetail.styles";
import { ReviewClassDetailPageTable } from "../ReviewClassDetailPageTable/ReviewClassDetailPageTable";

export interface ReviewClassLeftSectionProps {
    setSelectedRow: (data: any) => void;
    tableData: Array<any>;
    classDetails: {
        class_name: string;
        auth_code: string;
        created_at: any;
        discharged_patients: number;
        total_patients: number;
        average_score: number;
    };
    translations: any;
}

const ReviewClassLeftSection: React.FC<ReviewClassLeftSectionProps> = ({
    tableData,
    setSelectedRow,
    classDetails, // Receive class details as props
    translations,
}) => {
    console.log("Left Section Translations", translations);
    const diseaseTableColumns = [
        {
            key: "name",
            accessor: "name",
            label: "Name of Disease",
        },
        {
            key: "no_of_patients",
            accessor: "no_of_patients",
            label: "Number of Patients",
        },
        {
            key: "average_score",
            accessor: "average_score",
            label: "Average Score",
        },
    ];
    return (
        <ReviewPageLeftSection>
            <DetailContainer>
                <DetailCardWrapper>
                    <DetailCard>
                        <Heading>Class Information</Heading>
                        <Paragraph>
                            Class Name: <Span>{classDetails.class_name}</Span>
                        </Paragraph>
                        <Paragraph>
                            Class Code:{" "}
                            <Span>
                                <AuthCode>{classDetails.auth_code}</AuthCode>
                            </Span>
                        </Paragraph>
                        <Paragraph>
                            Patients Seen:{" "}
                            <Span>{classDetails.total_patients}</Span>
                        </Paragraph>
                        <Paragraph>
                            Patients Discharged:{" "}
                            <Span> {classDetails.discharged_patients}</Span>
                        </Paragraph>
                        <Paragraph>
                            Date Created:{" "}
                            <Span> {classDetails.created_at}</Span>
                        </Paragraph>
                        <Paragraph>
                            Average Score Overall:{" "}
                            <Span>{classDetails.average_score}</Span>
                        </Paragraph>
                    </DetailCard>
                    <DetailCard>
                        <Heading>Per Disease Information</Heading>
                        <ReviewClassDetailPageTable
                            data={tableData}
                            columns={diseaseTableColumns}
                        />
                    </DetailCard>
                </DetailCardWrapper>
                
            </DetailContainer>
        </ReviewPageLeftSection>
    );
};

export default ReviewClassLeftSection;
